module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-LightItalic.90682da2.otf";